module.exports = __webpack_public_path__ + "img/v4_17.4d3c88b5.png";